/*glob-patterns*/
/*examples*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "文件全局变量规范",
  "description": "了解 `turbo` 使用的文件全局规范。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 中使用文件通配符 (globs) 来配置在各种上下文中要包含或排除的文件，从而允许你明确定义希望 turbo 使用的文件。"
  }, {
    "heading": "",
    "content": "¥File globs are used throughout Turborepo for configuring which files to include or exclude in various contexts, allowing you to specifically define the files you want turbo to use."
  }, {
    "heading": "通配符模式-glob-patterns",
    "content": "¥Glob patterns"
  }, {
    "heading": "通配符模式-glob-patterns",
    "content": "模式"
  }, {
    "heading": "通配符模式-glob-patterns",
    "content": "描述"
  }, {
    "heading": "通配符模式-glob-patterns",
    "content": "*"
  }, {
    "heading": "通配符模式-glob-patterns",
    "content": "匹配目录中的所有文件"
  }, {
    "heading": "通配符模式-glob-patterns",
    "content": "**"
  }, {
    "heading": "通配符模式-glob-patterns",
    "content": "递归匹配所有文件和子目录"
  }, {
    "heading": "通配符模式-glob-patterns",
    "content": "some-dir/"
  }, {
    "heading": "通配符模式-glob-patterns",
    "content": "匹配 some-dir 目录及其内容"
  }, {
    "heading": "通配符模式-glob-patterns",
    "content": "some-dir"
  }, {
    "heading": "通配符模式-glob-patterns",
    "content": "匹配名为 some-dir 或 some-dir 目录的文件及其内容"
  }, {
    "heading": "通配符模式-glob-patterns",
    "content": "some-dir*"
  }, {
    "heading": "通配符模式-glob-patterns",
    "content": "匹配以 some-dir 开头的文件和目录，匹配目录时包含其内容"
  }, {
    "heading": "通配符模式-glob-patterns",
    "content": "*.js"
  }, {
    "heading": "通配符模式-glob-patterns",
    "content": "匹配目录中的所有 .js 文件"
  }, {
    "heading": "通配符模式-glob-patterns",
    "content": "!"
  }, {
    "heading": "通配符模式-glob-patterns",
    "content": "取反整个 glob（自动将 /** 应用于定义的 glob 末尾）"
  }, {
    "heading": "示例-examples",
    "content": "¥Examples"
  }, {
    "heading": "示例-examples",
    "content": "模式"
  }, {
    "heading": "示例-examples",
    "content": "描述"
  }, {
    "heading": "示例-examples",
    "content": "dist/**"
  }, {
    "heading": "示例-examples",
    "content": "匹配 dist 目录中的所有文件、其内容及所有子目录"
  }, {
    "heading": "示例-examples",
    "content": "dist/"
  }, {
    "heading": "示例-examples",
    "content": "匹配 dist 目录及其内容"
  }, {
    "heading": "示例-examples",
    "content": "dist"
  }, {
    "heading": "示例-examples",
    "content": "匹配名为 dist 或 dist 目录的文件、其内容及所有子目录"
  }, {
    "heading": "示例-examples",
    "content": "dist/some-dir/**"
  }, {
    "heading": "示例-examples",
    "content": "匹配 dist/some-dir 目录中的所有文件以及当前目录中的所有子目录"
  }, {
    "heading": "示例-examples",
    "content": "!dist"
  }, {
    "heading": "示例-examples",
    "content": "忽略 dist 目录及其所有内容"
  }, {
    "heading": "示例-examples",
    "content": "dist*"
  }, {
    "heading": "示例-examples",
    "content": "匹配以 dist 开头的文件和目录"
  }, {
    "heading": "示例-examples",
    "content": "dist/*.js"
  }, {
    "heading": "示例-examples",
    "content": "匹配 dist 目录中的所有 .js 文件"
  }, {
    "heading": "示例-examples",
    "content": "!dist/*.js"
  }, {
    "heading": "示例-examples",
    "content": "忽略 dist 目录中的所有 .js 文件"
  }, {
    "heading": "示例-examples",
    "content": "dist/**/*.js"
  }, {
    "heading": "示例-examples",
    "content": "递归匹配 dist 目录及其子目录中的所有 .js 文件"
  }, {
    "heading": "示例-examples",
    "content": "../scripts/**"
  }, {
    "heading": "示例-examples",
    "content": "向上一级目录，匹配 scripts 目录中的所有文件和子目录"
  }],
  "headings": [{
    "id": "通配符模式-glob-patterns",
    "content": "通配符模式 /*glob-patterns*/"
  }, {
    "id": "示例-examples",
    "content": "示例 /*examples*/"
  }]
};
export const toc = [{
  depth: 2,
  url: "#通配符模式-glob-patterns",
  title: _jsx(_Fragment, {
    children: "通配符模式 "
  })
}, {
  depth: 2,
  url: "#示例-examples",
  title: _jsx(_Fragment, {
    children: "示例 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    code: "code",
    h2: "h2",
    p: "p",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["Turborepo 中使用文件通配符 (globs) 来配置在各种上下文中要包含或排除的文件，从而允许你明确定义希望 ", _jsx(_components.code, {
        children: "turbo"
      }), " 使用的文件。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥File globs are used throughout Turborepo for configuring which files to include or exclude in various contexts, allowing you to specifically define the files you want ", _jsx(_components.code, {
        children: "turbo"
      }), " to use."]
    }), "\n", _jsx(_components.h2, {
      id: "通配符模式-glob-patterns",
      children: "通配符模式 "
    }), "\n", _jsx(_components.p, {
      children: "¥Glob patterns"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "模式"
          }), _jsx(_components.th, {
            children: "描述"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "*"
            })
          }), _jsx(_components.td, {
            children: "匹配目录中的所有文件"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "**"
            })
          }), _jsx(_components.td, {
            children: "递归匹配所有文件和子目录"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "some-dir/"
            })
          }), _jsxs(_components.td, {
            children: ["匹配 ", _jsx(_components.code, {
              children: "some-dir"
            }), " 目录及其内容"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "some-dir"
            })
          }), _jsxs(_components.td, {
            children: ["匹配名为 ", _jsx(_components.code, {
              children: "some-dir"
            }), " 或 ", _jsx(_components.code, {
              children: "some-dir"
            }), " 目录的文件及其内容"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "some-dir*"
            })
          }), _jsxs(_components.td, {
            children: ["匹配以 ", _jsx(_components.code, {
              children: "some-dir"
            }), " 开头的文件和目录，匹配目录时包含其内容"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "*.js"
            })
          }), _jsxs(_components.td, {
            children: ["匹配目录中的所有 ", _jsx(_components.code, {
              children: ".js"
            }), " 文件"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "!"
            })
          }), _jsxs(_components.td, {
            children: ["取反整个 glob（自动将 ", _jsx(_components.code, {
              children: "/**"
            }), " 应用于定义的 glob 末尾）"]
          })]
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "示例-examples",
      children: "示例 "
    }), "\n", _jsx(_components.p, {
      children: "¥Examples"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "模式"
          }), _jsx(_components.th, {
            children: "描述"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "dist/**"
            })
          }), _jsxs(_components.td, {
            children: ["匹配 ", _jsx(_components.code, {
              children: "dist"
            }), " 目录中的所有文件、其内容及所有子目录"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "dist/"
            })
          }), _jsxs(_components.td, {
            children: ["匹配 ", _jsx(_components.code, {
              children: "dist"
            }), " 目录及其内容"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "dist"
            })
          }), _jsxs(_components.td, {
            children: ["匹配名为 ", _jsx(_components.code, {
              children: "dist"
            }), " 或 ", _jsx(_components.code, {
              children: "dist"
            }), " 目录的文件、其内容及所有子目录"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "dist/some-dir/**"
            })
          }), _jsxs(_components.td, {
            children: ["匹配 ", _jsx(_components.code, {
              children: "dist/some-dir"
            }), " 目录中的所有文件以及当前目录中的所有子目录"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "!dist"
            })
          }), _jsxs(_components.td, {
            children: ["忽略 ", _jsx(_components.code, {
              children: "dist"
            }), " 目录及其所有内容"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "dist*"
            })
          }), _jsxs(_components.td, {
            children: ["匹配以 ", _jsx(_components.code, {
              children: "dist"
            }), " 开头的文件和目录"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "dist/*.js"
            })
          }), _jsxs(_components.td, {
            children: ["匹配 ", _jsx(_components.code, {
              children: "dist"
            }), " 目录中的所有 ", _jsx(_components.code, {
              children: ".js"
            }), " 文件"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "!dist/*.js"
            })
          }), _jsxs(_components.td, {
            children: ["忽略 ", _jsx(_components.code, {
              children: "dist"
            }), " 目录中的所有 ", _jsx(_components.code, {
              children: ".js"
            }), " 文件"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "dist/**/*.js"
            })
          }), _jsxs(_components.td, {
            children: ["递归匹配 ", _jsx(_components.code, {
              children: "dist"
            }), " 目录及其子目录中的所有 ", _jsx(_components.code, {
              children: ".js"
            }), " 文件"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "../scripts/**"
            })
          }), _jsxs(_components.td, {
            children: ["向上一级目录，匹配 ", _jsx(_components.code, {
              children: "scripts"
            }), " 目录中的所有文件和子目录"]
          })]
        })]
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
